import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
	name: 'priceUnit'
})

export class PriceUnitPipe implements PipeTransform
{
	transform(value: string): string
	{
		if (environment.price_units) {
			return environment.price_units[value];
		}

		return value;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/price-unit.pipe.ts